import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListCtl, ServiceLocatorService } from '@ncs/ncs-lib';
import { Router } from '@angular/router';
import { getFilterLable } from '../app.utils';
import { Editor, Toolbar, toHTML } from 'ngx-editor';
import { schema } from 'ngx-editor';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ChangeDetectorRef } from '@angular/core';
import { ImageTransform } from 'ngx-image-cropper';
import { HttpResponse } from '@angular/common/http';
declare var bootstrap: any;
import * as QRCode from 'qrcode';

@Component({
  selector: 'app-usecase-database',
  templateUrl: './usecase-database.component.html',
  styleUrls: ['./usecase-database.component.scss'],
})
export class UsecaseDatabaseComponent extends BaseListCtl {
  public applicationId: number = 0;

  public usecaseName: string = 'NoName';
  public usecaseSchema: any = {};

  //Contains schema attributes
  public attributeList: any = [];

  public usecaseDataList = [];
  public usecaseId: number = 0;
  public usecasePreload: any = {};
  //Contains usecase help data
  public usecaseHelp: any = {};

  public attributeId: number = 0;

  public formListRecord: number = 0;

  getFilterLable = getFilterLable;

  activetab = 'usecase-list-tab';
  searchValues: any = {};

  public commentList: any = [];
  public attachmentList: any = [];
  public appAttachmentInfo: any;
  public appCommentInfo: any;

  isHovered: boolean = false;

  onMouseEnter() {
    this.isHovered = true;
  }

  onMouseLeave() {
    this.isHovered = false;
  }

  sortedField: string | null = null;
  sortOrder: 'ASC' | 'DESC' | null = null;

  showSearchInputs = false;

  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute,
    private router: Router,
    private sanitizer: DomSanitizer
  ) {
    super('', locator, route);
    locator.config
      .getProperty('endpoint.userstory')
      .then((property: string) => {
        this.initApiEndpoint(property);
      });
    let _self = this;

    // -------------------------------
    // Check Coming from App User Button
    // -------------------------------
    this.route.queryParams.subscribe((params) => {
      const fromUserButton =
        params['fromUserButton'] === 'true' ||
        params['fromUserButton'] === true;

      if (fromUserButton) {
        _self.UserListT = true; // show table
        console.log('Coming from User Button');
      } else {
        _self.UserListT = false; // hide table
      }
    });

    _self.applicationId = Number(this.route.snapshot.paramMap.get('appId'));
    _self.form.data['appId'] = _self.applicationId;
    _self.form.searchParams['appId'] = _self.applicationId;
    // _self.form.searchParams['orderBy'] = 'name';

    _self.getApplicationDetails(_self.applicationId);

    _self.getUsers();

    _self.searchArchived();
    _self.form.data['groupFilter'] = 1;
  }

  getApplicationDetails(id: any) {
    let _self = this;
   
    let url = _self.locator.config.get('endpoint.application') + '/get/' + id;

    _self.locator.http.get(url, (res: any, error: boolean) => {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
        _self.applogo = res.result.data['logo'];
    });
  }

  searchArchived(callback?: any) {
    var _self = this;

    _self.form.searchError = false;
    _self.form.searchMessage = ''; 
    this.locator.config
      .getProperty('endpoint.userstory')
      .then((property: string) => {
        let url = property + '/searchArchived/' + _self.form.pageNo;
        _self.form.searchParams['pageSize'] = _self.form.pageSize;

        this.locator.http.post(
          url,
          _self.form.searchParams,
          function (res: any, error: any) {
            if (error) {
              if (callback) {
                callback(error);
              }

              return;
            }

            _self.form.searchError = !res.success;
            _self.form.searchMessage = res.result['message'];

            if (res.success) {
              _self.form.archivedlist = res.result.data;
              _self.form.pageCount = res.result.pageCount;
              _self.form.pageSize = res.result.pageSize;
              _self.form.pageNos = _self.form.pageNo;
              _self.form.pageNoList = [];
              //Build page number list
              for (let i = 0; i < _self.form.pageCount; i++) {
                _self.form.pageNoList.push(i);
              }

              //Check empty list
              if (_self.form.archivedlist.length == 0) {
                _self.form.message = 'No record found';
                _self.form.error = true;
              }

              // Add data in Datatable
              //_self.initializeDataTable();

              if (callback) {
                callback();
              }
            }

            if (callback) {
              callback();
            }
          }
        );
      });
  }

  public searchUsecaseItem: string = '';
  /**
   *
   * @returns Filter useacases
   */
  public filterUsecases(): any {
    let searchTerm = this.searchUsecaseItem.toLowerCase();
    return this.form.list.filter((e: any) =>
      (e['name'] + '').toLowerCase().includes(searchTerm)
    );
  }

  search1() {
    let _self = this;
    alert(_self.form.id);
    // if (_self.form.searchParams['applicationId']) {
    //   super.search();
    // } else {
    //   _self.resetSearchList();
    // }
  }

  resetSearchList() {
    this.form.list = [];
  }
  public showTable = false;

  //public usecaseId:any;

  onUsecaseSelect(): void {
    this.showTable = true;
    this.UserListT = false;
    const id = this.form.searchParams['usecaseId'];
    if (id && id !== 'undefined') {
      this.usecaseId = id;
      this.getUsecaseSchema();
    }
  }

  //public attributeList: any = [];

  //showSearchInputs = false;

  //searchValues: any = {};

  /**
   * Get usecase schema
   */
  public async getUsecaseSchema() {
    let _self = this;
    _self.locator.config
      .getProperty('endpoint.userstory')
      .then((property: string) => {
        let url =
          _self.locator.config.get('endpoint.userstory') +
          '/get/' +
          _self.usecaseId;

        _self.locator.http.get(url, async function (res: any, error: boolean) {
          if (error) {
            alert('Server Error:' + error);
            return;
          }
          _self.usecaseSchema = res.result.data;
          _self.attributeId = _self.usecaseSchema['appId'];
          _self.enabletag = _self.usecaseSchema['tagenable'];
          _self.getUsecaseDataList();
          _self.getUsecasePreloadData();
        });

        let attrUrl =
          _self.locator.config.get('endpoint.userstory.attributes') +
          '/list/' +
          _self.usecaseId;
        //{ userstoryId: _self.usecaseId },
        _self.locator.http.get(attrUrl, function (res: any, error: boolean) {
          _self.attributeList = res.result.data;
          _self.attributeList = _self.attributeList.filter(
            (item: any) => item?.disable != 1 && item?.type !== 'tag',
          );
          _self.setHtmlEditor();
        });
      });
  }

  onReferenceValueChange(e: any, value: string) {
    this.searchValues[e.code] = parseFloat(value);
  }

  public getInputType(t: string) {
    switch (t) {
      case 'date':
        return 'date';
      case 'idate':
        return 'date';
      case 'number':
      case 'decimal':
        return 'number';
      case 'text':
        return 'text';
      case 'time':
        return 'time';
      case 'itime':
        return 'time';
      case 'file':
        return 'file';
      case 'textarea':
        return 'text';
      case 'dateandtime':
        return 'datetime-local';
      case 'password':
        return 'password';
      default:
        return 'text';
    }
  }

  onValueChange(e: any, value: string) {
    this.searchValues[e.code] = e.type === 'number' ? parseFloat(value) : value;
  }

  filteredData: any[] = [];
  /**
   * get usecase records list
   */

  filterTable() {
    this.filteredData = this.usecaseDataList.filter((item) => {
      return Object.keys(this.searchValues).every((key) => {
        const searchValue = this.searchValues[key]?.toLowerCase();

        const itemValue = (item[key] as string | number | undefined)
          ?.toString()
          .toLowerCase();

        return !searchValue || itemValue?.includes(searchValue);
      });
    });
  }

  public async getUsecaseDataList() {
    let _self = this;

    let searchdata = Object.fromEntries(
      Object.entries(this.searchValues).filter(
        ([_, value]) =>
          value !== null &&
          value !== undefined &&
          value !== 'undefined' &&
          value !== ''
      )
    );

    Object.keys(searchdata).forEach((key) => {
      let value = searchdata[key];
      const attr = this.attributeList.find((a: any) => a.code === key);

      if (attr) {
        if (attr.type === 'list') {
          searchdata[key] = String(value);
        } else if (attr.type === 'dateandtime') {
          try {
            const utcIso = new Date(value as string).toISOString();
            searchdata[key] = utcIso;
          } catch (err) {
            console.warn('Invalid datetime for search:', value);
          }
        } else if (attr.type === 'idate') {
          try {
            const utcIso = new Date(value as string).toISOString();
            searchdata[key] = utcIso;
          } catch (err) {
            console.warn('Invalid datetime for search:', value);
          }
        } else if (attr.type === 'itime') {
          try {
            const valStr = String(value);
            // if input format is HH:mm
            if (valStr.length === 5) {
              value = `1970-01-01T${valStr}:00`;
            }
            searchdata[key] = new Date(value as string).toISOString();
          } catch {
            console.warn('Invalid time:', value);
          }
        } else if (attr.type === 'email') {
          searchdata[key] = String(value).trim();
        } else if (attr.type === 'text' || attr.type === 'textarea') {
          searchdata[key] = String(value).trim();
        } else {
          if (typeof value === 'string' && value.trim() !== '') {
            const isNumeric = /^-?\d+(\.\d+)?$/.test(value);
            if (isNumeric) {
              searchdata[key] = Number(value);
            }
          }
        }
      }
    });

    searchdata = this.setSearchData(searchdata);
    let url = _self.getAPIBaseUrl() + '/search/' + _self.form.pageNo;
    _self.locator.http.post(
      url,
      searchdata,
      async function (res: any, error: boolean) {
        if (error) {
          alert('Server Error:' + error);
          return;
        }
        _self.usecaseDataList = res.result['data'];
        _self.formListRecord = res.result.recordCount;
        _self.filteredData = [..._self.usecaseDataList];

        _self.form.pageCount = res.result.pageCount;
        _self.form.pageSize = res.result.pageSize;
        _self.form.pageNos = res.result.pageNo;
        _self.form.pageNoList = [];
        for (let i = 0; i < _self.form.pageCount; i++) {
          _self.form.pageNoList.push(i);
        }
        if (_self.usecaseDataList.length == 0) {
          _self.form.message = 'No record found';
          _self.form.error = true;
        }
      }
    );
    _self.searchArchived();
    _self.searchTrash();
  }

  enforceMaxDate(event: Event, fieldCode: string, fieldType: string): void {
    console.log('hello world ');
    if (fieldType === 'date') {
      console.log('hello world');
      const input = event.target as HTMLInputElement;
      const maxDate = new Date('9999-12-31');
      const enteredDate = new Date(input.value);

      // If invalid or too large, reset
      if (enteredDate > maxDate) {
        input.value = '9999-12-31';
        this.form[fieldCode] = '9999-12-31';
      } else {
        this.form[fieldCode] = input.value;
      }
    }
  }

  getAPIBaseUrl(suburl?: string) {
    let _self = this;
    let updatedName = _self.usecaseSchema?.collectionName?.replace(/\./g, '/');
    let url = _self.locator.config.get('endpoint.api.v1') + '/' + updatedName;
    if (suburl) {
      url += '/' + suburl;
    }
    return url;
  }

  searchTrash(callback?: any) {
    var _self = this;

    _self.form.searchError = false;
    _self.form.searchMessage = '';

    let url = _self.getAPIBaseUrl() + '/searchTrash/' + _self.form.pageNo;
    _self.form.searchParams['pageSize'] = _self.form.pageSize;

    this.locator.http.post(
      url,
      _self.form.searchParams,
      function (res: any, error: any) {
        if (error) {
          if (callback) {
            callback(error);
          }

          return;
        }

        _self.form.searchError = !res.success;
        _self.form.searchMessage = res.result['message'];

        if (res.success) {
          _self.form.trashlist = res.result.data;
          _self.form.pageCount = res.result.pageCount;
          _self.form.pageSize = res.result.pageSize;
          _self.form.pageNos = res.result.pageNo;
          _self.form.pageNoList = [];
          //Build page number list
          for (let i = 0; i < _self.form.pageCount; i++) {
            _self.form.pageNoList.push(i);
          }

          //Check empty list
          if (_self.form.trashlist.length == 0) {
            _self.form.message = 'No record found';
            _self.form.error = true;
          }

          // Add data in Datatable
          //_self.initializeDataTable();

          if (callback) {
            callback();
          }
        }

        if (callback) {
          callback();
        }
      }
    );
  }

  getDescription(field: any) {
    if (field['description']) {
      return field['description'];
    }

    return field['label'];
  }

  resetSearch() {
    var _self = this;
    _self.searchValues = {};
    _self.getUsecaseDataList();
  }

  public exportData() {
    let _self = this;
    let url = _self.urlRewrite(_self.getAPIBaseUrl('export'));
    _self.locator.http
      .getClient()
      .post(url, {}, { responseType: 'blob' })
      .subscribe(
        (data: any) => {
          _self.downloadDataAsFile(data, 'export.csv');
        },
        (data: any) => {
          console.error(data);
        }
      );
  }

  urlRewrite(endpoint: string) {
    let keySuffix = this.locator.config.get('CONTEXT_PATH') + '-';
    let sid = localStorage.getItem(keySuffix + 'sessionId');
    if (!sid) {
      sid = '0';
    }
    endpoint = endpoint + ';jsessionid=' + sid;
    return endpoint;
  }

  public downloadDataAsFile(data: any, fileName: string) {
    //Create a dynamic link and download file
    let file = new window.Blob([data], { type: data.type });
    const downloadAncher = document.createElement('a');
    downloadAncher.style.display = 'none';
    const fileURL = URL.createObjectURL(file);
    downloadAncher.href = fileURL;
    downloadAncher.download = fileName;
    downloadAncher.click();
  }

  public exportPDFData() {
    let _self = this;
    let url = _self.urlRewrite(_self.getAPIBaseUrl('pdf'));
    //let endpoint = this.httpService.urlRewrite(url);
    _self.locator.http
      .getClient()
      .post(url, {}, { responseType: 'blob' })
      .subscribe(
        (data: any) => {
          _self.downloadDataAsFile(data, 'export.pdf');
        },
        (data: any) => {
          console.error(data);
        }
      );
  }

  // public exportPDFDataList() {
  //   console.log('Hello world : ');

  //   const url = this.urlRewrite(this.getAPIBaseUrl('pdflist'));
  //   // const payload = this.getSearchCriteria();
  //   const payload = {};

  //   console.log('URL:', url);
  //   console.log('Payload:', payload);

  //   this.locator.http
  //     .getClient()
  //     .post(url, payload)
  //     .subscribe(
  //       (response: any) => {
  //         console.log('PDF Response:', response);

  //         // Extract message (backend supports 2 formats)
  //         const message =
  //           response?.message ||
  //           response?.result?.message ||
  //           'Something went wrong';

  //         // Show message in UI (you are not using message service)
  //         this.form['message'] = message;
  //         this.form['error'] = !response?.success;

  //         if (!response.success) {
  //           // Failure case (show only message)
  //           //  console.warn('Export failed:', message);
  //           return;
  //         }

  //         // Success message
  //         console.log('PDF request saved successfully.');
  //       },

  //       (error: any) => {
  //         console.error('PDF Export Error:', error);

  //         // Extract message correctly from backend error
  //         const message =
  //           error?.error?.message ||
  //           error?.error?.result?.message ||
  //           'Server error, please try again.';

  //         this.form['message'] = message;
  //         this.form['error'] = true;
  //       }
  //     );
  // }

  public exportPDFDataEmail() {
    const url = this.urlRewrite(this.getAPIBaseUrl('pdflist'));

    console.log("url : ",url);

    const payload = this.getSearchCriteria();

    console.log('url : ', payload);

    payload['totalCount'] = this.formListRecord;

    this.locator.http
      .getClient()
      .post(url, payload, {
        responseType: 'blob',
        observe: 'response',
      })
      .subscribe({
        next: (response: HttpResponse<Blob>) => {
          const contentType = response.headers.get('content-type');

          // PDF response
          if (contentType && contentType.includes('application/pdf')) {
            const blob = new Blob([response.body!], {
              type: 'application/pdf',
            });
            const downloadUrl = window.URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = downloadUrl;
            a.download = 'NcsIndore_Report.pdf';
            a.click();

            window.URL.revokeObjectURL(downloadUrl);
            return;
          }

          // JSON response (email flow)
          const reader = new FileReader();
          reader.onload = () => {
            const json = JSON.parse(reader.result as string);
            this.form['message'] = json.message;
            this.form['error'] = !json.success;
          };
          reader.readAsText(response.body!);
        },

        error: (error: any) => {
          console.error('PDF Export Error:', error);
          this.form['message'] = 'Server error, please try again.';
          this.form['error'] = true;
        },
      });
  }

  public getSearchCriteria() {
    let searchdata = Object.fromEntries(
      Object.entries(this.searchValues).filter(
        ([_, value]) =>
          value !== null &&
          value !== undefined &&
          value !== 'undefined' &&
          value !== ''
      )
    );

    Object.keys(searchdata).forEach((key) => {
      let value = searchdata[key];
      const attr = this.attributeList.find((a: any) => a.code === key);
      if (attr) {
        if (attr.type === 'list') {
          searchdata[key] = String(value);
        } else if (attr.type === 'dateandtime') {
          try {
            const utcIso = new Date(value as string).toISOString();
            searchdata[key] = utcIso;
          } catch (err) {
            console.warn('Invalid datetime for search:', value);
          }
        } else if (attr.type === 'idate') {
          try {
            const utcIso = new Date(value as string).toISOString();
            searchdata[key] = utcIso;
          } catch (err) {
            console.warn('Invalid date for search:', value);
          }
        } else if (attr.type === 'itime') {
          try {
            const valStr = String(value);
            // if input format is HH:mm
            if (valStr.length === 5) {
              value = `1970-01-01T${valStr}:00`;
            }
            searchdata[key] = new Date(value as string).toISOString();
          } catch {
            console.warn('Invalid time:', value);
          }
        } else {
          if (typeof value === 'string' && value.trim() !== '') {
            const isNumeric = /^-?\d+(\.\d+)?$/.test(value);
            if (isNumeric) {
              searchdata[key] = Number(value);
            }
          }
        }
        }
    });

    searchdata = this.setSearchData(searchdata);
    return searchdata;
  }

  public exportSampleData() {
    let _self = this;
    let url = _self.urlRewrite(_self.getAPIBaseUrl('exportSampleCSV'));
    _self.locator.http
      .getClient()
      .post(url, {}, { responseType: 'blob' })
      .subscribe(
        (data: any) => {
          _self.downloadDataAsFile(data, 'export.csv');
        },
        (data: any) => {
          console.error(data);
        }
      );
  }

  uploadResult = {
    uploadId: null as number | null,
    totalRows: 0,
    successRows: 0,
    errorRows: 0
  };
  // Replace your existing onCsvFileUpload method with this updated version
  public onCsvFileUpload(event: any) {
    const fileObj = event.target.files[0];
    var _self = this;
    _self.form.error = false;
    _self.form.message = '';
    
    let url = _self.locator.config.get('endpoint.userstory') + '/importCSV/' + _self.usecaseId;
    var param = {
      id: this.form.data.id,
    };
    
    this.locator.http.postMutipart(
      url,
      param,
      fileObj,
      function (res: any, error: any) {
        if (error) {
          alert(error);
          return;
        }
        
        _self.form.error = !res.success;
        
        if (res.success) {
          _self.form.message = 'File uploaded successfully';
          
          // Populate upload result
          _self.uploadResult = {
            uploadId: res.result.uploadId || null,
            totalRows: res.result.totalRows || 0,
            successRows: res.result.successfulUploads || 0,
            errorRows: res.result.errorRows || 0
          };
          
          // Show the summary modal
          const summaryModal = new bootstrap.Modal(document.getElementById('uploadSummaryModal'));
          summaryModal.show();
          
          // Refresh the list
          _self.search();
        } else {
          alert(res.message);
        }
      }
    );
  }
  
  changeTab(targetId: string) {
    const targetTab = document.querySelector(`button[id="${targetId}"]`);
    if (targetTab) {
      const bootstrapTab = new bootstrap.Tab(targetTab); // Initialize Bootstrap tab
      bootstrapTab.show(); // Show the target tab
    }
  }

  public isArchivedlistTabActive: boolean = false;
  public isTrashTabActive: boolean = false;

  toggleTab(tab: string): void {
    this.isArchivedlistTabActive = tab === 'archivedlist';
    this.isTrashTabActive = tab === 'trashlist';
    if (this.isTrashTabActive) {
      this.isArchivedlistTabActive = true;
    }
  }

  toggleSearchInputs() {
    this.showSearchInputs = !this.showSearchInputs;
  }

  sortTable(field: string): void {
    let _self = this;
    if (this.sortedField === field) {
      this.sortOrder = this.sortOrder === 'ASC' ? 'DESC' : 'ASC';
    } else {
      this.sortedField = field;
      this.sortOrder = 'ASC';
    }
    _self.form.searchParams['orderBy'] = this.sortedField;
    _self.form.searchParams['asc'] = this.sortOrder;
    _self.getUsecaseDataList();
  }

  public getString(val: any, type: string) {
    if (val) {
      if (type === 'object') {
        val = JSON.stringify(val);
      }
      if (type === 'dateandtime') {
        try {
          const utcDate = new Date(val);
          const d = new Date(utcDate);
          const year = d.getFullYear();
          const month = (d.getMonth() + 1).toString().padStart(2, '0');
          const day = d.getDate().toString().padStart(2, '0');
          const hours = d.getHours().toString().padStart(2, '0');
          const minutes = d.getMinutes().toString().padStart(2, '0');
          const localISO = `${year}-${month}-${day} ${hours}:${minutes}`;
          return localISO;
        } catch (err) {
          return val;
        }
      }
      if (type === 'idate') {
        try {
          const utcDate = new Date(val);
          const d = new Date(utcDate);
          const year = d.getFullYear();
          const month = (d.getMonth() + 1).toString().padStart(2, '0');
          const day = d.getDate().toString().padStart(2, '0');
          const hours = d.getHours().toString().padStart(2, '0');
          const minutes = d.getMinutes().toString().padStart(2, '0');
          const localISO = `${year}-${month}-${day}`;
          return localISO;
        } catch (err) {
          return val;
        }
      }
      if (type == 'itime') {
        const d = new Date(val);
        const hh = d.getHours().toString().padStart(2, '0');
        const mm = d.getMinutes().toString().padStart(2, '0');
        const localISO = `${hh}:${mm}`;
        return localISO;
      }
      return val;
    } else {
      return '';
    }
  }

  public getStringBoolean(val: any, type: string): any {
    if (val !== null && val !== undefined) {
      if (type === 'object') {
        val = JSON.stringify(val);
      }
      return val;
    } else {
      return '';
    }
  }

  ele: any;
  tooltipContent: string = '';

  openInfoModal(data: any): void {
    this.ele = data;

    // Initialize and show the modal using Bootstrap's JavaScript API
    this.tooltipContent = this.getTooltipContent();

    const modalElement = document.getElementById('infoModal');
    if (modalElement) {
      const modal = new bootstrap.Modal(modalElement);
      modal.show(); // Show the modal
    }
  }

  getTooltipContent(): string {
    if (!this.ele) {
      return 'No data available';
    }

    return `
      <div class="table-container">
        <div class="table-responsive">
        <table class="table table-bordered table-hover">
            <thead>
                <tr>
                    <th>Key</th>
                    <th>Values</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Org</td>
                    <td>${this.ele.orgName || 'N/A'}</td>
                </tr>
                <tr>
                    <td>Usecase</td>
                    <td>${this.ele.usecaseName || 'N/A'}</td>
                </tr>
                <tr>
                    <td>Skey</td>
                    <td>${this.ele.skey || 'N/A'}</td>
                </tr>
                <tr>
                    <td>Version</td>
                    <td>${this.ele.version || 'N/A'}</td>
                </tr>
                <tr>
                    <td>Created By</td>
                    <td>${this.ele.createdBy || 'N/A'}</td>
                </tr>
                <tr>
                    <td>Created Date</td>
                    <td>${this.formatDate(this.ele.createdDatetime)}</td>
                </tr>
                <tr>
                    <td>Modified By</td>
                    <td>${this.ele.modifiedBy || 'N/A'}</td>
                </tr>
                <tr>
                    <td>Modified Date</td>
                    <td>${this.formatDate(this.ele.modifiedDatetime)}</td>
                </tr>
                <tr>
                    <td>Version History</td>
                    <td>${this.ele.versionHistory || 'N/A'}</td>
                </tr>
                <tr>
                    <td>Archive Enabled</td>
                    <td>${this.ele.archiveEnabled || 'N/A'}</td>
                </tr>
                <tr>
                    <td>Change Log</td>
                    <td>${this.ele.changeLog || 'N/A'}</td>
                </tr>
                <tr>
                    <td>Group Filter</td>
                    <td>${this.ele.groupFilter || 'N/A'}</td>
                </tr>
            </tbody>
        </table>
     </div>
    </div>`;
  }

  formatDate(date: any): string {
    if (!date) return 'N/A';
    return new Date(date).toLocaleString();
  }

  public getUsecaseData(id: number) {
    let _self = this;
    if (!(id > 0)) {
      return;
    }

    let url = _self.getAPIBaseUrl('get') + '/' + id;
    _self.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      //_self.form['data'] = res.result['data'];
      _self.cleanAndSetData(res.result['data']);
    });
    _self.getUsecasePreloadData();
  }
  checkExpression: any;

  cleanAndSetData(data: any) {
    let _self = this;
    const sanitizedItem: any = {};
    _self.attributeList.forEach((attr: any) => {
      let key = attr['code'];
      if (key in data) {
        let value = data[key];
        if (attr.type === 'dateandtime' && value) {
          try {
            const utcDate = new Date(value);
            const d = new Date(utcDate);
            const year = d.getFullYear();
            const month = (d.getMonth() + 1).toString().padStart(2, '0');
            const day = d.getDate().toString().padStart(2, '0');
            const hours = d.getHours().toString().padStart(2, '0');
            const minutes = d.getMinutes().toString().padStart(2, '0');
            const localISO = `${year}-${month}-${day}T${hours}:${minutes}`;
            sanitizedItem[key] = localISO;
          } catch (err) {
            sanitizedItem[key] = value;
          }
        } else if (attr.type === 'idate' && value) {
          try {
            const utcDate = new Date(value);
            const d = new Date(utcDate);
            const year = d.getFullYear();
            const month = (d.getMonth() + 1).toString().padStart(2, '0');
            const day = d.getDate().toString().padStart(2, '0');
            const hours = d.getHours().toString().padStart(2, '0');
            const minutes = d.getMinutes().toString().padStart(2, '0');
            const localISO = `${year}-${month}-${day}`;
            sanitizedItem[key] = localISO;
          } catch (err) {
            sanitizedItem[key] = value;
          }
        } else if (attr.type === 'itime' && value) {
          try {
            const utcDate = new Date(value);
            const d = new Date(utcDate);
            const hh = d.getHours().toString().padStart(2, '0');
            const mm = d.getMinutes().toString().padStart(2, '0');
            const localISO = `${hh}:${mm}`;
            sanitizedItem[key] = localISO;
          } catch (err) {
            sanitizedItem[key] = value;
          }
        } else {
          sanitizedItem[key] = value;
        }
      }
    });

    if ('id' in data) {
      sanitizedItem['id'] = data['id'];
    }
    _self.form['data'] = sanitizedItem;
    this.attributeList?.forEach((e: any) => {
      if (e.type === 'textarea' && e.enableEditor === 1 && data[e.code]) {
        this.form['data'][e.code] = data[e.code];

        // Important: ngx-editor instance setContent
        const editorInstance = this.editors[e.code];
        if (editorInstance) {
          editorInstance.setContent(data[e.code]);
        }
        this.checkExpression = data['id'];
      }
    });

    _self.getCommentList(_self.form['data']['id']);
    _self.getattachmentList(_self.form['data']['id']);
  }

  //------show Password---------
  showPassword: boolean = false;

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }
  public async getUsecasePreloadData() {
    let _self = this;
    let url = _self.getAPIBaseUrl('preload');

    this.locator.http.get(url, async function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      _self.form['preload'] = res.result;
    });
  }

  public deleteUsecaseData(id: number) {
    let _self = this;
    if (!(id > 0)) {
      return;
    }

    let flag = confirm('Are you sure');
    if (!flag) {
      return;
    }

    let url = _self.getAPIBaseUrl('delete') + '/' + id;

    this.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      _self.form.error = !res.success;
      _self.form.message = res.message;
      _self.form['inputerror'] = res.result['inputerror'];
      if (res.success) {
        _self.getUsecaseDataList();
        _self.getUsecasePreloadData();
      }
    });
  }

  async retrieve(id: any, callback?: any) {
    var _self = this;
    _self.form.error = false;
    _self.form.message = '';
    if (id && id > 0) {
      if (_self.form.isConfirmDelete) {
        let flag = confirm('Are you sure ?');
        if (!flag) {
          return;
        }
      }
      let url = _self.getAPIBaseUrl() + '/retrieve/' + id;
      this.locator.http.get(url, async function (res: any, error: any) {
        if (error) {
          return;
        }
        _self.form.error = !res.success;
        _self.form.message = res.result.message;
        if (res.success) {
          _self.form.message = 'Data is retrieved';
          _self.searchArchived();
          _self.search();
          if (callback) {
            callback(res, error);
          }
        }
      });
    }
  }

  isArray(val: any): boolean {
    return Array.isArray(val);
  }

  public getInputError(name: string) {
    let _self = this;
    let errMsg = '';
    let ie = _self.form['inputerror'];
    if (ie && ie[name]) {
      errMsg = ie[name];
    }
    return errMsg;
  }

  public clearUniqueMessage(name: string) {
    let _self = this;
    let errMsg = '';
    _self.form['inputerror'][name] = '';
  }

  public filterAttributes(): any {
    return this.attributeList.filter((e: any) => e['system'] != 1);
  }

  restrictDecimalPlaces(event: Event, label: any, placeValue: number): void {
    const input = event.target as HTMLInputElement;
    if (!input.value) {
      this.evaluateExpressionFieldsNumberBeforeSave();
      return;
    }
    const value = input.value;
    const parts = value.split('.');
    if (parts.length === 2 && parts[1].length > placeValue) {
      this.form['error'] = true;
      this.form['message'] =
        'Only ' + placeValue + ' decimal value allowed on ' + label;
      input.value = `${parts[0]}.${parts[1].substring(0, placeValue)}`;
    }

    this.evaluateExpressionFieldsNumberBeforeSave();
  }

  public onChange(e: any, val: any) {
    let _self = this;
    let l = _self.form.preload[e['primaryUsecase']];
    let col = e['depAttribute'];
    for (let i = 0; i < l.length; i++) {
      if (l[i]['id'] == val.target.value) {
        _self.form.data[col] = l[i]['name'];
        //alert(_self.form.data[col]);
      }
    }
    //alert(val.target.value);

    this.evaluateExpressionFieldsBeforeSave();
  }

  public getPrimaryUsecase(attribute: any) {
    if (
      this.form.preload &&
      attribute &&
      attribute['primaryUsecase'] &&
      this.form.preload[attribute['primaryUsecase']]
    ) {
      return this.form.preload[attribute['primaryUsecase']];
    }

    return [];
  }

  /**
   *
   * @param event
   * @param code
   * @param imageId
   */
  // public onFileChanged(event: any, code: string, imageId: any) {
  //   const fileObj = event.target.files[0];
  //   var _self = this;
  //   if (imageId === null || imageId === undefined) {
  //     imageId = 0;
  //   }
  //   let url = _self.getAPIBaseUrl(
  //     'doc/' + _self.form.data['id'] + '/' + imageId + '/' + code
  //   );
  //   var param = {
  //     id: this.form.data.id,
  //   };
  //   this.locator.http.postMutipart(
  //     url,
  //     param,
  //     fileObj,
  //     function (res: any, error: any) {
  //       if (error) {
  //         alert(error);
  //         return;
  //       }
  //       _self.form.error = !res.success;
  //       _self.form.message = res.result.message;
  //       if (res.success) {
  //         _self.form.message = 'file is uploaded';
  //         _self.form.data[code] = res.result.data.imageId;
  //         _self.changeDoc();
  //         _self.getDocThumbnail(_self.form.data[code]);
  //       }
  //     }
  //   );
  // }

  combobox: any;

  public saveUsecaseData() {
    let _self = this;
    let url = _self.urlRewrite(_self.getAPIBaseUrl('save'));
    _self.combobox = _self.attributeList.filter(
      (item: any) => item.type === 'combobox'
    );
    let dateAndTime = _self.attributeList.filter(
      (item: any) => item.type === 'dateandtime'
    );
    let timeattributes = _self.attributeList.filter(
      (item: any) => item.type === 'itime'
    );
    let idateData = _self.attributeList.filter(
      (item: any) => item.type === 'idate'
    );

   const textAttributes = _self.attributeList?.filter(
     (item: any) => item.type === 'text' || item.type === 'textarea' || item.type === 'email' || item.type === 'password'
   );

    const entryformLabels = Object.keys(_self.form['data']);

    this.attributeList?.forEach((e: any) => {
      if (
        e.type === 'textarea' &&
        e.enableEditor === 1 &&
        this.editors[e.code]
      ) {
        const json = this.editors[e.code].view.state.doc.toJSON();
        const html = toHTML(json, schema);
        this.form.data[e.code] = html;
      }
    });

    // --- Create payload copy ---
    const filteredData = JSON.parse(JSON.stringify(_self.form['data']));

    dateAndTime.forEach((item: any) => {
      if (entryformLabels?.includes(item.code)) {
        const value = _self.form['data'][item.code];
        const utcIso = new Date(value).toISOString();
        filteredData[item.code] = utcIso;
      }
    });

    idateData.forEach((item: any) => {
      if (entryformLabels?.includes(item.code)) {
        const value = _self.form['data'][item.code];
        const utcIso = new Date(value).toISOString();
        filteredData[item.code] = utcIso;
      }
    });
    timeattributes.forEach((item: any) => {
      if (entryformLabels?.includes(item.code)) {
        let value = _self.form['data'][item.code];
        if (value && value.length === 5) {
          value = `1970-01-01T${value}:00`;
        }
        const utcIso = new Date(value).toISOString();
        filteredData[item.code] = utcIso;
      }
    });

    textAttributes?.forEach((attr: any) => {
      const key = attr.code;
      const value = filteredData[key];

      if (typeof value === 'string') {
        const trimmed = value.trim();

        // If only spaces → treat as empty string
        //_self.form['data'][key] = trimmed.length === 0 ? null : trimmed;

         if (trimmed.length === 0) {
           //  Remove field completely from payload
          delete filteredData[key];
         } else {
           //  Save trimmed value
          filteredData[key] = trimmed;
         }
      }
    });

    _self.combobox.forEach((item: any) => {
      if (entryformLabels.includes(item.code)) {
        const entryValue = _self.form['data'][item.code];
        if (entryValue && !item.values.includes(entryValue)) {
          let isValid = true;
          if (item.regex) {
            const regex = new RegExp(item.regex);
            isValid = regex.test(entryValue);
          }

          if (isValid) {
            item.values.push(entryValue);
          }

          // Prepare data to send to API
          const payload = {
            label: item.label,
            type: item.type,
            userstoryId: item.userstoryId,
            id: item.id,
            values: item.values,
          };

          // Define API endpoint
          let url =
            _self.locator.config.get('endpoint.userstory.attributes') + '/save';

          // Make API call to save updated combobox
          _self.locator.http.post(url, payload, (res: any, error: boolean) => {
            if (error) {
              alert('Server Error: ' + error);
              return;
            }
          });
        }
      }
    });

    // Convert empty string to null
    Object.keys(filteredData).forEach((key) => {
      if ((filteredData as any)[key] === '') {
        (filteredData as any)[key] = null;
      }
    });

    // Fix: Remove the key/value pair from _self.form['data'] if the value is null
    Object.keys(filteredData).forEach((key) => {
      // Check specifically for null value
      if ((filteredData as any)[key] === null) {
        delete (filteredData as any)[key]; // Removes the key from the object
      }
    });

    _self.locator.http.post(
      url,
      filteredData,
      function (res: any, error: boolean) {
        if (error) {
          alert('Server Error:' + error);
          return;
        }
        _self.form['error'] = !res.success;
        _self.form['message'] = res.message;
        //Preserve previous inputerror
        const previousErrors = { ..._self.form['inputerror'] };

        // Set new inputerror
        _self.form['inputerror'] = res.result?.inputerror || {};
        if (res.result?.inputerror?.key) {
          _self.form['message'] = res.result['inputerror']['key'];
        }

        // Smart cleanup of fixed errors
        Object.keys(previousErrors).forEach((key) => {
          const val = _self.form['data'][key];
          const errorMsg = (previousErrors[key] || '').toLowerCase();
          const isEmpty = val === null || val === undefined;
          const wasRequired = errorMsg.includes('required');
          const wasInvalid = errorMsg.includes('invalid');
          const stillHasError = _self.form['inputerror'].hasOwnProperty(key);

          if (stillHasError) return;

          if (
            (isEmpty && !wasRequired) || // optional empty field
            (!isEmpty && !wasInvalid) // corrected input
          ) {
            delete _self.form['inputerror'][key];
          }
        });

        if (res.success) {
          _self.form['data']['id'] = res.result['data']['id'];
          _self.cleanAndSetData(res.result['data']);

          const hasImages =
            _self.imageFiles && Object.keys(_self.imageFiles).length > 0;
          const hasDocs =
            _self.docFiles && Object.keys(_self.docFiles).length > 0;

          if (hasImages && hasDocs) {
            _self
              .uploadImagesThenSaveForm(_self.imageFiles)
              .then(() => _self.uploadImagesThenSaveForm(_self.docFiles))
              .then(() => _self.finalSubmitForm())
              .catch((err) => {
                console.error('Upload failed:', err);
                alert('File upload failed.');
              });
          } else if (hasImages) {
            _self
              .uploadImagesThenSaveForm(_self.imageFiles)
              .then(() => _self.finalSubmitForm())
              .catch((err) => {
                console.error('Image upload failed:', err);
                alert('Image upload failed.');
              });
          } else if (hasDocs) {
            _self
              .uploadImagesThenSaveForm(_self.docFiles)
              .then(() => _self.finalSubmitForm())
              .catch((err) => {
                console.error('Document upload failed:', err);
                alert('Document upload failed.');
              });
          }
          _self.getUsecaseDataList();
          _self.search();
        }
      }
    );
  }

  getInitials(fullName: string): string {
    if (!fullName) return '';

    // Split the name at uppercase letters or space
    const words = fullName.replace(/([a-z])([A-Z])/g, '$1 $2').split(' ');

    // Get the first character of the first and second words (if available)
    const initials = words
      .slice(0, 2)
      .map((word) => word.charAt(0).toUpperCase())
      .join('');

    return initials;
  }

  commentform: any = {
    error: false,
    message: '',
    data: { id: 0 }, //form data
  };

  /**
   * Get Comment List
   */
  public getComment(recordId: any) {
    let _self = this;
    _self.commentform['error'] = [];
    _self.commentform['message'] = '';
    _self.commentform['inputerror'] = [];

    let updatedName = _self.usecaseSchema['collectionName'].replace(/\./g, '/');

    let url =
      _self.locator.config.get('endpoint.api.v1') +
      '/cuickdev/page-comment/get/' +
      recordId;

    _self.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      _self.commentform['error'] = !res.success;
      _self.commentform['message'] = res.message;
      if (res.result?.inputerror?.key) {
        _self.commentform['inputerror'] = res.result['inputerror']['key'];
      } else {
        _self.commentform['inputerror'] = res.result['inputerror'];
      }

      if (res.success) {
        _self.commentform['data'] = res.result['data'];
      }
    });
  }

  /**
   * Get Comment List
   */
  public getCommentList(recordId: any) {
    let _self = this;
    let searchform: any = {};
    _self.commentform['error'] = [];
    _self.commentform['message'] = '';
    _self.commentform['inputerror'] = [];
    _self.commentList = [];

    searchform['applicationId'] = _self.usecaseSchema['appId'];
    searchform['userstoryId'] = _self.usecaseSchema['id']; //usecase id
    // searchform['usecaseId'] = _self.usecase['id']; //usecase id
    searchform['recordId'] = _self.form['data']['id']; //record id
    searchform['orderBy'] = 'modifiedDatetime';
    searchform['asc'] = 'DESC';

    let updatedName = _self.usecaseSchema['collectionName'].replace(/\./g, '/');

    let url =
      _self.locator.config.get('endpoint.api.v1') +
      '/cuickdev/page-comment/search';

    _self.locator.http.post(
      url,
      searchform,
      function (res: any, error: boolean) {
        if (error) {
          alert('Server Error:' + error);
          return;
        }
        _self.commentform['error'] = !res.success;
        _self.commentform['message'] = res.message;
        if (res.result?.inputerror?.key) {
          _self.commentform['inputerror'] = res.result['inputerror']['key'];
        } else {
          _self.commentform['inputerror'] = res.result['inputerror'];
        }

        if (res.success) {
          _self.commentList = res.result['data'];
        }
      }
    );
  }

  resetcommentForm(): void {
    this.commentform = {
      data: { id: 0 }, //form data
    };
  }

  /**
   * Delete comment and update new list
   *
   * @param recordId
   * @param callback
   * @returns
   */
  public deleteComment(recordId: any, callback?: any) {
    let _self = this;

    if (recordId && recordId > 0) {
      if (_self.form.isConfirmDelete) {
        let flag = confirm('Are you sure ?');
        if (!flag) {
          return;
        }
      }

      _self.commentform['error'] = [];
      _self.commentform['message'] = '';
      _self.commentform['inputerror'] = [];

      let url =
        _self.locator.config.get('endpoint.api.v1') +
        '/cuickdev/page-comment/delete/' +
        recordId;

      _self.locator.http.get(url, function (res: any, error: boolean) {
        if (error) {
          alert('Server Error:' + error);
          return;
        }

        _self.commentform['error'] = !res.success;
        _self.commentform['message'] = res.message;

        if (res.result?.inputerror?.key) {
          _self.commentform['inputerror'] = res.result['inputerror']['key'];
        } else {
          _self.commentform['inputerror'] = res.result['inputerror'];
        }

        if (res.success) {
          _self.getCommentList(_self.form['data']['id']);
        }
      });
    }
  }

  public sform: any = {
    data: {},
  };
  public addPageComment() {
    let _self = this;

    _self.commentform['error'] = [];
    _self.commentform['message'] = '';
    _self.commentform['inputerror'] = [];

    _self.commentform['data']['applicationId'] = _self.usecaseSchema['appId'];
    _self.commentform['data']['userstoryId'] = _self.usecaseSchema['id']; //usecase id
    _self.commentform['data']['usecaseId'] = _self.usecaseSchema['id']; //usecase id
    _self.commentform['data']['recordId'] = _self.form['data']['id']; //record id

    let updatedName = _self.usecaseSchema['collectionName'].replace(/\./g, '/');

    let url = _self.urlRewrite(
      _self.locator.config.get('endpoint.api.v1') +
        '/' +
        updatedName +
        '/addComment'
    );

    _self.locator.http.post(
      url,
      _self.commentform['data'],
      function (res: any, error: boolean) {
        if (error) {
          alert('Server Error:' + error);
          return;
        }
        _self.commentform['error'] = !res.success;
        _self.commentform['message'] = 'Comment add successfully';
        if (res.result?.inputerror?.key) {
          _self.commentform['inputerror'] = res.result['inputerror']['key'];
        } else {
          _self.commentform['inputerror'] = res.result['inputerror'];
        }

        if (res.success) {
          _self.commentform['data']['id'] = res.result['data']['id'];
          _self.getCommentList(_self.form['data']['id']);
          alert('Comment add successfully');
        }
      }
    );
  }

  // atachment

  attfileObj: any;

  imageAttachmentPreview: string | ArrayBuffer | null = null;

  attachmentform: any = {
    error: false,
    message: '',
    data: { id: 0 }, //form data
  };

  /**
   * Reset attachment form
   */
  resetattachmentForm(): void {
    this.attachmentform = {
      data: { id: 0 }, //form data
    };
    this.imageAttachmentPreview = null;
    this.attfileObj = null;
    this.attForm['data'] = {};
  }

  /**
   * Add Page attachment
   */
  public addPageattachment() {
    let _self = this;

    _self.attachmentform['error'] = [];
    _self.attachmentform['message'] = '';
    _self.attachmentform['inputerror'] = [];

    _self.attachmentform['data']['applicationId'] =
      _self.usecaseSchema['appId'];
    _self.attachmentform['data']['userstoryId'] = _self.usecaseSchema['id']; //usecase id
    _self.attachmentform['data']['usecaseId'] = _self.usecaseSchema['id']; //usecase id
    _self.attachmentform['data']['recordId'] = _self.form['data']['id']; //record id

    let updatedName = _self.usecaseSchema['collectionName'].replace(/\./g, '/');

    let url = _self.urlRewrite(
      _self.locator.config.get('endpoint.api.v1') +
        '/' +
        updatedName +
        '/addattachment'
    );

    _self.locator.http.post(
      url,
      _self.attachmentform['data'],
      function (res: any, error: boolean) {
        if (error) {
          alert('Server Error:' + error);
          return;
        }
        _self.attachmentform['error'] = !res.success;
        _self.attachmentform['message'] = 'attachment add successfully';
        if (res.result?.inputerror?.key) {
          _self.attachmentform['inputerror'] = res.result['inputerror']['key'];
        } else {
          _self.attachmentform['inputerror'] = res.result['inputerror'];
        }

        if (res.success) {
          _self.attachmentform['data']['id'] = res.result['data']['id'];
          _self.getattachmentList(_self.form['data']['id']);
          alert('attachment add successfully');
        }
      }
    );
  }

  /**
   * Upload attatchment document
   * @param event
   */
  public onAttachmentformChanged(event: any) {
    var _self = this;
    _self.attfileObj = event.target.files[0];
    _self.showPreview(event);
  }

  showPreview(event: any) {
    const target = event.target as HTMLInputElement;
    const file = target.files ? target.files[0] : null;

    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        this.imageAttachmentPreview = reader.result; // Set the image preview
      };
      reader.readAsDataURL(file); // Convert the file to base64 URL
    }
  }

  saveAttachment() {
    var _self = this;
    let url = _self.getAPIBaseUrl('addAttechment');
    _self.setAttriForm();
    if (!_self.attfileObj || _self.attfileObj.length === 0) {
      const formData = new FormData();
      formData.append('id', this.attForm.id || '');
      formData.append('applicationId', this.attForm.applicationId || '');
      formData.append('userstoryId', this.attForm.userstoryId);
      formData.append('formId', this.attForm.formId);
      formData.append('recordId', this.attForm.recordId);
      formData.append('description', this.attForm.description);

      // **Only append the file if it exists and is not empty**
      if (this.attfileObj && this.attfileObj.length > 0) {
        formData.append('file', this.attfileObj[0]); // Assuming single file upload
      }

      this.locator.http.post(
        url,
        formData,
        function (res: any, error: boolean) {
          if (error) {
            alert('Server Error:' + error);
            return;
          }
          if (res.success) {
            alert('file is uploaded');
            _self.getattachmentList(_self.form['data']['id']);
          }
        }
      );
      return;
    }

    this.locator.http.postMutipart(
      url,
      _self.attForm,
      _self.attfileObj,
      function (res: any, error: any) {
        if (error) {
          alert(error);
          return;
        }
        _self.attachmentform.error = !res.success;
        _self.attachmentform.message = res.result.message;
        if (res.success) {
          _self.getattachmentList(_self.form['data']['id']);
          _self.attachmentform.message = 'file is uploaded';
          _self.attachmentform['data'] = res.result['data'];
          _self.changeDoc();
          // _self.getDoc(_self.form.data[code]);
        }
      }
    );
  }

  /**
   * Get attachment List
   */
  public getattachmentList(recordId: any) {
    let _self = this;
    let searchform: any = {};
    _self.attachmentform['error'] = [];
    _self.attachmentform['message'] = '';
    _self.attachmentform['inputerror'] = [];
    _self.attachmentList = [];

    searchform['applicationId'] = _self.usecaseSchema['appId'];
    searchform['userstoryId'] = _self.usecaseSchema['id']; //usecase id
    // searchform['usecaseId'] = _self.usecase['id']; //usecase id
    searchform['recordId'] = _self.form['data']['id']; //record id
    searchform['orderBy'] = 'modifiedDatetime';
    searchform['asc'] = 'DESC';

    let updatedName = _self.usecaseSchema['collectionName'].replace(/\./g, '/');

    let url =
      _self.locator.config.get('endpoint.api.v1') +
      '/cuickdev/page-attachment/search';

    _self.locator.http.post(
      url,
      searchform,
      function (res: any, error: boolean) {
        if (error) {
          alert('Server Error:' + error);
          return;
        }
        _self.attachmentform['error'] = !res.success;
        _self.attachmentform['message'] = res.message;
        if (res.result?.inputerror?.key) {
          _self.attachmentform['inputerror'] = res.result['inputerror']['key'];
        } else {
          _self.attachmentform['inputerror'] = res.result['inputerror'];
        }

        if (res.success) {
          _self.attachmentList = res.result['data'];
        }
      }
    );
  }

  setAttriForm() {
    var _self = this;

    _self.attForm = {
      id: _self.attachmentform.data?.id,
      applicationId: _self.usecaseSchema['appId'],
      userstoryId: _self.usecaseSchema['id'],
      usecaseId: _self.usecaseSchema['id'],
      recordId: _self.form['data']['id'],
      formId: _self.form['data']['id'],
      description: _self.attachmentform['data']['description'],
    };
  }

  /**
   * Get attachment List
   */
  public getattachment(recordId: any) {
    let _self = this;
    _self.attachmentform['error'] = [];
    _self.attachmentform['message'] = '';
    _self.attachmentform['inputerror'] = [];

    let updatedName = _self.usecaseSchema['collectionName'].replace(/\./g, '/');

    let url =
      _self.locator.config.get('endpoint.api.v1') +
      '/cuickdev/page-attachment/get/' +
      recordId;

    _self.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      _self.attachmentform['error'] = !res.success;
      _self.attachmentform['message'] = res.message;
      if (res.result?.inputerror?.key) {
        _self.attachmentform['inputerror'] = res.result['inputerror']['key'];
      } else {
        _self.attachmentform['inputerror'] = res.result['inputerror'];
      }

      if (res.success) {
        _self.attachmentform['data'] = res.result['data'];
        _self.setAttriForm();
      }
    });
  }

  /**
   * Delete attachment and update new list
   *
   * @param recordId
   * @param callback
   * @returns
   */
  public deleteattachment(recordId: any, callback?: any) {
    let _self = this;

    if (recordId && recordId > 0) {
      if (_self.form.isConfirmDelete) {
        let flag = confirm('Are you sure ?');
        if (!flag) {
          return;
        }
      }

      _self.attachmentform['error'] = [];
      _self.attachmentform['message'] = '';
      _self.attachmentform['inputerror'] = [];

      let url =
        _self.locator.config.get('endpoint.api.v1') +
        '/cuickdev/page-attachment/delete/' +
        recordId;

      _self.locator.http.get(url, function (res: any, error: boolean) {
        if (error) {
          alert('Server Error:' + error);
          return;
        }

        _self.attachmentform['error'] = !res.success;
        _self.attachmentform['message'] = res.message;

        if (res.result?.inputerror?.key) {
          _self.attachmentform['inputerror'] = res.result['inputerror']['key'];
        } else {
          _self.attachmentform['inputerror'] = res.result['inputerror'];
        }

        if (res.success) {
          _self.getattachmentList(_self.form['data']['id']);
        }
      });
    }
  }

  attForm: any = {
    data: {}, // data
  };

  masterSelected: boolean = false;
  selectAll() {
    this.filteredData.forEach((item: any) => {
      item.selected = this.masterSelected;
    });
  }

  checkIfAllSelected() {
    this.masterSelected = this.filteredData.every((item: any) => item.selected);
  }
  Deleteall() {
    const selectedItems = this.filteredData.filter((item) => item.selected);

    this.deleteUseSelectedUseCase(selectedItems, (deletedIds: any[]) => {
      // Only remove items from UI if they were successfully deleted
      this.filteredData = this.filteredData.filter(
        (item) => !deletedIds.includes(item.id)
      );
      this.masterSelected = false;

      // Refresh list or do any additional processing
      this.getUsecaseDataList();

      console.log('Successfully deleted IDs:', deletedIds);
    });
  }

  public async deleteUseSelectedUseCase(data: any[], callback?: any) {
    if (!data || data.length === 0) return;

    const confirmed = confirm(
      'Are you sure you want to delete selected records?'
    );
    if (!confirmed) return;

    const successfullyDeletedIds: any[] = [];
    let completedRequests = 0;

    data.forEach((element: any) => {
      let url = this.getAPIBaseUrl('delete') + '/' + element.id;

      this.locator.http.get(url, (res: any, error: boolean) => {
        completedRequests++;

        if (!error && res.success) {
          successfullyDeletedIds.push(element.id);
        } else if (error) {
          alert('Server Error: ' + error);
        }

        if (completedRequests === data.length) {
          if (callback) callback(successfullyDeletedIds);
        }
      });
    });
  }

  location = ''; // string bound to input field
  latitude = 0;
  longitude = 0;

  setCurrentLocation(code: string) {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;

          if (!this.form.data[code]) {
            this.form.data[code] = {};
          }

          this.form.data[code].lat = lat;
          this.form.data[code].lng = lng;

          console.log(`📍 Location set: Lat = ${lat}, Lng = ${lng}`);
        },
        (error) => {
          console.error('❌ Geolocation error:', error);
          alert(
            'Unable to get your location. Please allow location access in the browser.'
          );
        }
      );
    } else {
      alert('Geolocation is not supported by your browser.');
    }
  }

  viewOnMap(code: string) {
    const location = this.form.data[code];
    const lat = location?.lat;
    const lng = location?.lng;

    if (lat && lng) {
      const mapUrl = `https://www.google.com/maps?q=${lat},${lng}`;
      window.open(mapUrl, '_blank');
    } else {
      alert('Location not available. Please set the location first.');
    }
  }

  clearLocation(code: string) {
    if (this.form.data[code]) {
      this.form.data[code].lat = null;
      this.form.data[code].lng = null;
    }
  }

  imagePreview: string | ArrayBuffer | null = null;

  // onFileChooseClicked(fileInput: any, code: any) {
  //     if (fileInput) {
  //       fileInput.value = '';
  //     }
  //     this.imageSizes[code] = false;
  //     this.imagePreviews[code] = null;
  //     this.fileErrors[code] = false;
  // }

  imageFiles: { [key: string]: File } = {};
  docFiles: { [key: string]: File } = {};

  imagePreviews: { [key: string]: string | ArrayBuffer | null } = {};
  fileErrors: { [key: string]: boolean } = {};
  imageSizes: { [key: string]: boolean } = {};

  uploadFileToServer(file: File, code: string, imageId: any): Promise<any> {
    if (imageId === null || imageId === undefined) {
      imageId = 0;
    }

    const url = this.getAPIBaseUrl(
      `doc/${this.form.data['id']}/${imageId}/${code}`
    );
    const param = { id: this.form.data.id };

    return new Promise((resolve, reject) => {
      this.locator.http.postMutipart(
        url,
        param,
        file,
        (res: any, error: any) => {
          if (error) {
            reject(error);
          } else {
            this.form.error = !res.success;
            this.form.message = res.result.message;
            if (res.success) {
              this.form.message = 'File is uploaded';
              this.form.data[code] = res.result.data[code];
              this.changeDoc();
              this.getDoc(this.form.data[code]);
            }
            resolve(res);
          }
        }
      );
    });
  }

  uploadImagesThenSaveForm(Files: any): Promise<void> {
    let _self = this;

    const fileKeys = Object.keys(Files);
    const uploadPromises = fileKeys.map((code) => {
      const file = Files[code];
      return _self.uploadFileToServer(file, code, 0);
    });

    return Promise.all(uploadPromises).then((responses) => {
      responses.forEach((response: any, index: number) => {
        const imageId = response.result?.data?.imageId;
        if (imageId) {
          _self.form['data'][fileKeys[index]] = imageId;
        }
      });
    });
  }

  finalSubmitForm() {
    let _self = this;
    let url = _self.urlRewrite(_self.getAPIBaseUrl('save'));

    const entryformLabels = Object.keys(_self.form['data']);
    let dateAndTime = _self.attributeList.filter(
      (item: any) => item.type == 'dateandtime'
    );
    let timeattributes = _self.attributeList.filter(
      (item: any) => item.type == 'itime'
    );
    dateAndTime.forEach((item: any) => {
      if (entryformLabels?.includes(item.code)) {
        const value = _self.form['data'][item.code];
        const utcIso = new Date(value).toISOString();
        _self.form['data'][item.code] = utcIso;
      }
    });

    timeattributes.forEach((item: any) => {
      if (entryformLabels?.includes(item.code)) {
        let value = _self.form['data'][item.code];
        if (value && value.length === 5) {
          value = `1970-01-01T${value}:00`;
        }
        const utcIso = new Date(value).toISOString();
        _self.form['data'][item.code] = utcIso;
      }
    });

    _self.locator.http.post(
      url,
      _self.form['data'],
      function (res: any, error: boolean) {
        if (error) {
          alert('Server Error:' + error);
          return;
        }

        _self.form['error'] = !res.success;
        _self.form['message'] = res.message;

        if (res.result?.inputerror?.key) {
          _self.form['message'] = res.result.inputerror.key;
        } else {
          _self.form['inputerror'] = res.result.inputerror;
        }

        if (res.success) {
          _self.form['data']['id'] = res.result.data.id;
          _self.cleanAndSetData(res.result['data']);
        } else {
          alert('Error while submitting form with image IDs');
        }
      }
    );
  }
  // HTML Editor
  editors: { [key: string]: Editor } = {};
  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    ['link'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];

  generateHtmlFromEditor(code: string): void {
    const value = this.form.data[code];
    console.log(`HTML Editor Content for ${code}:`, value);
  }
  getSanitizedHtml(html: any): SafeHtml {
    if (html && typeof html === 'object' && html.type === 'doc') {
      try {
        html = toHTML(html);
      } catch (err) {
        console.error('Failed to convert editor JSON to HTML:', err);
        html = '';
      }
    }

    // Ensure string fallback
    if (typeof html !== 'string') {
      html = String(html ?? '');
    }

    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
  removeHTMLTags(html: string): string {
    if (!html) return '';
    const div = document.createElement('div'); // Temporary element banayenge
    div.innerHTML = html; // HTML inject karenge
    return div.textContent || div.innerText || ''; // Sirf text milega, no tags
  }

  destroyHtmlEditor() {
    if (this.editors) {
      Object.keys(this.editors).forEach((key: string) => {
        const editor = this.editors[key];
        if (editor && typeof editor.destroy === 'function') {
          editor.destroy();
        }
        // Also clear the underlying textarea or div content
        const element = document.getElementById(
          key
        ) as HTMLTextAreaElement | null;
        if (element) {
          element.value = ''; // If it's a textarea
          element.innerHTML = ''; // If it's a div or contenteditable
        }
      });
    }
    this.editors = {};
  }

  setHtmlEditor() {
    var _self = this;
    _self.attributeList?.forEach((e: any) => {
      if (e.type === 'textarea' && e.enableEditor === 1) {
        _self.editors[e.code] = new Editor();
      }
    });
  }

  resetHtmlData() {
    this.attributeList?.forEach((e: any) => {
      if (e.type === 'textarea' && e.enableEditor === 1) {
        this.form.data[e.code] = '';
        const editorInstance = this.editors[e.code];
        if (editorInstance) {
          editorInstance.setContent(''); // Editor view clear
        }
      }
    });
  }
  public resetImgDoc() {
    this.resetForm();
    this.imageFiles = {};
    // this.docFileErrors ={};
    this.docFiles = {};
    // this.docSizes ={};
    this.imagePreviews = {};
    this.fileErrors = {};
    this.imageSizes = {};
    this.DocPreviews = {};
    const fileInputs = document.querySelectorAll('input[type="file"]');
    fileInputs.forEach((input) => {
      (input as HTMLInputElement).value = '';
    });
  }

  // onImageFileChanged(event: any, e: any, imageId: any) {

  //   console.log("e-->",e);
  //   let code =e.code;
  //  // console.log("code",e.size);

  //   const file = event.target.files[0];
  //   console.log("image type :: ",file.type);

  //   if (!file) return;
  //   // Validate file type
  //   const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
  //   if (!allowedTypes.includes(file.type)) {
  //     this.fileErrors[code] = true;
  //     this.imageSizes[code] = false;
  //     this.imagePreviews[code] = null;
  //     return;
  //   } else {
  //     this.fileErrors[code] = false;
  //   }

  //  if (e.size) {
  //   const maxSizeImg = e.size;
  //   const maxFileSizeInBytes = maxSizeImg * 1024 * 1024;

  //   if (file.size > maxFileSizeInBytes) {
  //     this.imageSizes[code] = true;
  //     this.fileErrors[code] = false;
  //     this.imagePreviews[code] = null;
  //     console.warn(`File size too large. Limit: ${maxSizeImg} MB`);
  //     return;
  //   } else {
  //     this.imageSizes[code] = false;
  //   }
  //  } else {
  //   // No size restriction
  //   console.log('No size limit specified, allowing any image size.');
  //   this.imageSizes[code] = false;
  //  }

  //   // Step 1: Show Preview First
  //   const reader = new FileReader();
  //   reader.onload = (e) => {
  //     this.imagePreviews[code] = e.target?.result as string;
  //     this.imageFiles[code] = file;

  //   };
  //   reader.readAsDataURL(file);
  // }

  DocPreviews: { [key: string]: string | ArrayBuffer | null } = {};
  docFileErrors: { [key: string]: boolean } = {};
  docSizes: { [key: string]: boolean } = {};

  public onFileChanged(event: any, e: any, imageId: any) {
    const code = e.code;
    const fileObj = event.target.files[0];
    var _self = this;
    if (imageId === null || imageId === undefined) {
      imageId = 0;
    }

    const allowedDocTypes = [
      'image/jpeg',
      'image/jpg',
      'image/png',
      'image/gif',
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/vnd.ms-excel', // .xls
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    ];

    if (!allowedDocTypes.includes(fileObj.type)) {
      this.docFileErrors[code] = true;
      this.docSizes[code] = false;
      this.DocPreviews[code] = null;
      return;
    } else {
      this.docFileErrors[code] = false;
    }

    const maxSizeDoc = e.size || 1;
    const maxFileSizeInBytes = maxSizeDoc * 1024 * 1024;
    if (fileObj.size > maxFileSizeInBytes) {
      this.docSizes[code] = true;
      this.docFileErrors[code] = false;
      this.DocPreviews[code] = null;
      return;
    } else {
      this.docSizes[code] = false;
    }
    this.docFiles[code] = fileObj;
    const reader = new FileReader();
    reader.onload = (e) => {
      this.DocPreviews[code] = e.target?.result as string;
      this.docFiles[code] = fileObj;
    };
    reader.readAsDataURL(fileObj);
  }

  toggleDropdown(e: any) {
    if (
      e['readOnly'] ||
      (e.allowChangeAfterInitial == 1 && this.form.data['id'] > 0)
    ) {
      return;
    }
    e.isDropdownOpen = !e.isDropdownOpen;
  }

  onCheckboxChange(e: any, option: any, event: any) {
    event.stopPropagation();
    if (!this.form.data[e.code]) {
      this.form.data[e.code] = [];
    }
    if (event.target.checked) {
      if (!this.form.data[e.code].includes(option)) {
        this.form.data[e.code].push(option);
      }
    } else {
      this.form.data[e.code] = this.form.data[e.code].filter(
        (o: any) => o !== option
      );
    }
    this.onChange(e, this.form.data[e.code]);
  }

  getSelectedText(e: any) {
    const value = this.form.data[e.code];
    if (e['multipleSelect'] == 1 && Array.isArray(value) && value.length) {
      return value.join(', ');
    }
    return '';
  }

  getString1(value: string, type: string, timeType?: string): string {
    if (type === 'time' && value) {
      const [hours, minutes] = value.split(':').map(Number);
      if (timeType === '12') {
        const hour12 = hours % 12 || 12;
        const ampm = hours < 12 ? 'AM' : 'PM';
        return `${hour12}:${minutes.toString().padStart(2, '0')} ${ampm}`;
      }
      // Default is 24-hour
      return `${hours.toString().padStart(2, '0')}:${minutes
        .toString()
        .padStart(2, '0')}`;
    }

    return value; // for other types
  }
  getStringitime(value: string, type: string, timeType?: string): string {
    if (type === 'itime' && value) {
      const d = new Date(value);
      let hours = d.getHours();
      const minutes = d.getMinutes().toString().padStart(2, '0');

      if (timeType === '12') {
        const hour12 = hours % 12 || 12;
        const ampm = hours < 12 ? 'AM' : 'PM';
        return `${hour12}:${minutes} ${ampm}`;
      }
      return `${hours.toString().padStart(2, '0')}:${minutes}`;
    }
    return value;
  }

  getLocationObject(value: any): { lat: number; lng: number } | null {
    if (!value) return null;

    if (typeof value === 'string') {
      try {
        const cleaned = value
          .replace(/lat\s*:\s*/i, '"lat":')
          .replace(/lng\s*:\s*/i, '"lng":')
          .replace(/'/g, '"');
        return JSON.parse(cleaned);
      } catch (e) {
        console.error('Invalid location string:', value);
        return null;
      }
    }

    if (typeof value === 'object' && value.lat && value.lng) {
      return value;
    }

    return null;
  }
  checklocation() {
    var _self = this;
    _self.attributeList.map((item: any) => {
      if (item.type == 'location') {
        _self.prepareLocationField(item.code);
      }
    });
  }

  prepareLocationField(code: string): void {
    const value = this.form.data[code];

    if (value && typeof value === 'string') {
      try {
        const cleaned = value
          .replace(/lat\s*:\s*/i, '"lat":')
          .replace(/lng\s*:\s*/i, '"lng":')
          .replace(/'/g, '"');

        this.form.data[code] = JSON.parse(`{${cleaned}}`);
      } catch (e) {
        this.form.data[code] = null;
      }
    }
  }

  getFilteredData(data: any[]) {
    return data;
  }

  onSearchReferenceValueChange1(e: any, value: any) {
    if (typeof value === 'object' && value !== null) {
      this.searchValues[e.code] =
        typeof value.id === 'number' ? Number(value.id) : String(value.id);
    } else {
      this.searchValues[e.code] = value ?? undefined;
    }
  }

  compareFn = (item1: any, item2: any) => {
    return item1 == item2;
  };

  filterFn = (term: string, item: any) => {
    if (!term) return true;
    term = term.toLowerCase();
    return item._val?.toLowerCase().includes(term);
  };

  // -----------------Image Crop Function--------------------------

  imageChangedEvent: any = '';
  croppedImage: string = '';
  activeCode: string = ''; // store which field is being cropped
  showCropper: boolean = false;
  transform: ImageTransform = {
    translateUnit: 'px',
    scale: 1,
    rotate: 0,
    flipH: false,
    flipV: false,
    translateH: 0,
    translateV: 0,
  };

  loading = false;
  canvasRotation = 0;
  cropperMinWidth = 0;
  cropperMinHeight = 0;
  cropperMaxWidth = 0;
  cropperMaxHeight = 0;
  cropperStaticWidth = 0;
  cropperStaticHeight = 0;
  containWithinAspectRatio = false;
  maintainAspectRatio = false;
  resetCropOnAspectRatioChange = true;
  aspectRatio = 4 / 3;
  alignImage = 'center' as const;
  roundCropper = false;
  hidden = false;
  disabled = false;
  hideResizeSquares = false;

  naturalWidth = 0;
  naturalHeight = 0;

  // fileErrors: { [key: string]: boolean } = {};
  // imageSizes: { [key: string]: boolean } = {};
  // imagePreviews: { [key: string]: string } = {};

  // open modal when file selected
  openCropperModal(event: any, code: string): void {
    const file = event.target.files[0];
    if (!file) return;

    // validate type
    const validTypes = ['image/jpeg', 'image/png', 'image/gif'];
    if (!validTypes.includes(file.type)) {
      this.fileErrors[code] = true;
      return;
    }
    this.fileErrors[code] = false;

    // validate size (1MB default)
    const maxSize = 1024 * 1024 * 1; // 1 MB
    if (file.size > maxSize) {
      this.imageSizes[code] = true;
      return;
    }
    this.imageSizes[code] = false;

    // set active field and open cropper
    this.activeCode = code;
    this.imageChangedEvent = event;
    this.showCropper = true;

    // open Bootstrap modal manually
    const modal: any = document.getElementById('imageModal');
    if (modal) {
      const bsModal = new (window as any).bootstrap.Modal(modal);
      bsModal.show();
    }
  }

  imageCropped(event: any) {
    console.log('Cropped event:', event);

    if (event && event.base64) {
      this.croppedImage = event.base64;
    } else if (event && event.blob) {
      // Convert blob to base64
      const reader = new FileReader();
      reader.onload = () => {
        this.croppedImage = reader.result as string; // now croppedImage is set
      };
      reader.readAsDataURL(event.blob);
    }
  }

  imageLoaded() {
    console.log('Image loaded ');
    const file = this.imageChangedEvent?.target?.files?.[0];
    if (!file) return;

    const img = new Image();
    img.onload = () => {
      this.naturalWidth = img.naturalWidth;
      this.naturalHeight = img.naturalHeight;

      // Reset transform to show full image
      this.transform = {
        scale: 1,
        rotate: 0,
        flipH: false,
        flipV: false,
        translateH: 0,
        translateV: 0,
        translateUnit: 'px',
      };
    };
    img.src = URL.createObjectURL(file);
  }
  cropperReady(event?: any) {
    console.log('Cropper ready', event);
  }
  loadImageFailed() {
    console.error('Load failed ');
  }

  // cancel crop
  cancelCrop() {
    this.showCropper = false;
    this.imageChangedEvent = '';
    this.croppedImage = '';
    this.activeCode = '';
  }

  // save cropped
  saveCroppedImage() {
    if (this.croppedImage && this.activeCode) {
      this.imagePreviews[this.activeCode] = this.croppedImage;

      // convert to file and update entryform
      const file = this.base64ToFile(this.croppedImage, 'cropped.png');

      if (!this.form.data) {
        this.form.data = {};
      }

      this.form.data[this.activeCode] = file;
      // important: keep consistency with onImageFileChanged
      this.imageFiles[this.activeCode] = file;

      console.log('Saved file for code:', this.activeCode, file);
    }

    this.cancelCrop();
  }

  // helper
  private base64ToFile(data: string, filename: string): File {
    const arr = data.split(',');
    const mime = arr[0].match(/:(.*?);/)?.[1] || 'image/png';
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  // Add inside your UiformEditComponent class
  onFileChooseClicked(file: any, code: string): void {
    console.log('File choose clicked:', code);
  }

  onImageFileChanged(event: any, e: any, code: string): void {
    console.log('Image file changed:', code, event);
    //  this.onFileChanged(event, code); // reuse existing method if you want
  }

  zoomIn() {
    this.transform = {
      ...this.transform,
      scale: this.transform.scale! + 0.1,
    };
  }

  zoomOut() {
    this.transform = {
      ...this.transform,
      scale: this.transform.scale! - 0.1,
    };
  }

  rotateRight() {
    this.loading = true;
    setTimeout(() => {
      this.canvasRotation++;
      this.flipAfterRotate();
    });
  }

  private flipAfterRotate() {
    const flippedH = this.transform.flipH;
    const flippedV = this.transform.flipV;
    this.transform = {
      ...this.transform,
      flipH: flippedV,
      flipV: flippedH,
      translateH: 0,
      translateV: 0,
    };
  }

  flipHorizontal() {
    this.transform = {
      ...this.transform,
      flipH: !this.transform.flipH,
    };
  }

  flipVertical() {
    this.transform = {
      ...this.transform,
      flipV: !this.transform.flipV,
    };
  }

  rotateLeft() {
    this.loading = true;
    setTimeout(() => {
      // Use timeout because rotating image is a heavy operation and will block the ui thread
      this.canvasRotation--;
      this.flipAfterRotate();
    });
  }

  // /---------------------------------------User Search ----------------------------------------------/

  public UserList: any[] = [];
  searchText: string = '';
  applicationRoles: string = '';
  searchLogicCode: string = '';
  searchMobile: string = '';
  UserListT: boolean = false;

  /**
   * Get users
   */
  getUsers() {
    const url =
      this.locator.getEndpoint('endpoint.user') +
      '/getUser/' +
      this.applicationId;

    this.locator.http.get(url, (res: any, error: boolean) => {
      if (error) {
        alert('Server Error: ' + error);
        this.UserList = [];
        return;
      }

      this.UserList = res.result?.data || [];
      console.log('User List:', this.UserList);
    });
  }

  resetFilters() {
    this.searchText = '';
    this.searchLogicCode = '';
    this.searchMobile = '';

    this.getUsers(); // reload full list
  }

  searchUsers() {
    const url =
      this.locator.getEndpoint('endpoint.user') +
      '/getUserSearch/' +
      this.applicationId;

    const payload: any = {
      appId: this.applicationId,
    };

    if (this.searchText?.trim()) {
      payload.login = this.searchText.trim();
    }

    if (this.searchLogicCode?.trim()) {
      payload.loginCode = this.searchLogicCode.trim();
    }

    if (this.searchMobile?.toString().trim()) {
      payload.mobileId = this.searchMobile.toString().trim();
    }

    console.log('Search Payload:', payload);

    this.locator.http.post(url, payload, (res: any, error: boolean) => {
      if (error) {
        alert('Server Error: ' + error);
        this.UserList = [];
        return;
      }

      this.UserList = res.result?.data || [];
      console.log('Filtered User List:', this.UserList);
    });
  }

  //------------------------------------------------Excel Funcationality on Expression Field ---------------------------
  evaluateCondition(attr: any): boolean {
    try {
      if (attr['show']) {
        const condition = attr['show'] as string;
        const context = this.form?.data || {};
        const variableRegex = /\b([a-zA-Z_][a-zA-Z0-9_]*)\b/g;
        const variablesInCondition = new Set(condition.match(variableRegex));
        const contextKeys = Object.keys(context);
        for (const variable of variablesInCondition) {
          if (!contextKeys.includes(variable) && isNaN(Number(variable))) {
            context[variable] = undefined;
          }
        }
        const fn = new Function(
          ...Object.keys(context),
          `return ${condition};`
        );

        const result = fn(...Object.values(context));
        return result;
      }
      return true;
    } catch (error) {
      return false;
    }
  }

  evaluateExpressionFieldsNumberBeforeSave() {
    if (!this.form || !this.form?.data) {
      return;
    }

    const allFields: any[] = this.attributeList || [];

    console.log(allFields);

    let updated = true;
    let iteration = 0;

    while (updated && iteration < 3) {
      updated = false;
      iteration++;

      for (const field of allFields) {
        if (field.type === 'expression' && field.expression) {
          let originalExpr: string = field.expression;
          let expr: string = originalExpr;

          // 1. Extract Dependencies
          const dependencies: string[] = (expr.match(/@\w[\w\s]*/g) || []).map(
            (d: string) => d.trim().replace('@', '')
          );

          // 2. Identify empty/missing dependencies
          const emptyDependencies: string[] = [];

          for (const dep of dependencies) {
            const depField = allFields.find((f: any) => f.label.trim() === dep);
            const depValue = depField ? this.form.data[depField.code] : null;

            // If the dependency value is empty, null, or undefined, add it to the empty list
            if (
              depValue === undefined ||
              depValue === null ||
              String(depValue).trim() === ''
            ) {
              emptyDependencies.push(dep);
            }
          }

          // 3. Dynamically RESTRICT the Expression
          // Remove empty dependency labels along with the preceding operator (+, -, *, /)
          if (emptyDependencies.length > 0) {
            for (const emptyDep of emptyDependencies) {
              const labelKey = `@${emptyDep}`;

              // Regular Expression to find the operator and the label, and remove both.
              // It looks for a math operator (+, -, *, /) followed by the field label.
              // We make the operator optional for the first term.
              const removalRegex = new RegExp(
                `[\\+\\-\\*/]?\\s*${labelKey}`,
                'g'
              );

              expr = expr.replace(removalRegex, '');
            }

            // Clean up any remaining leading/trailing operators or redundant spaces.
            // This is crucial to avoid expressions like * 25 + 32 (if the first field was removed).
            expr = expr
              .trim()
              .replace(/^[\+\-\*/]/, '')
              .trim();
          }

          // 4. Replace remaining @labels with their actual values (as strings for replacement)
          for (const f of allFields) {
            const labelKey = `@${f.label}`;
            let value = this.form.data[f.code];

            // Use the number value for substitution
            let numericValue = Number(value);
            if (isNaN(numericValue)) {
              numericValue = 0;
            }

            // FIX: Convert the number to a string for replacement
            expr = expr.replaceAll(labelKey, String(numericValue));
          }

          // 5. Run the Calculation
          try {
            // If the entire expression became empty (e.g., all fields were empty)
            if (expr.length === 0) {
              this.form.data[field.code] = null;
              updated = true;
              continue;
            }

            const result = Function('"use strict";return (' + expr + ')')();

            // Handle potential NaN/Infinity, set to null
            const finalResult =
              isNaN(result) ||
              !isFinite(result) ||
              result === null ||
              result === undefined
                ? null
                : result;

            if (this.form.data[field.code] !== finalResult) {
              let rounded =
                typeof finalResult === 'number'
                  ? Number(finalResult.toFixed(3))
                  : finalResult;

              this.form.data[field.code] = rounded;
              updated = true;
            }
          } catch (err) {
            console.error(
              `❌ Failed to evaluate ${field.code}: Expression: "${expr}"`,
              err
            );

            if (this.form.data[field.code] !== null) {
              this.form.data[field.code] = null;
              updated = true;
            }
          }
        }
      }
    }
  }

  evaluateExpressionFieldsBeforeSave() {
    if (!this.form || !this.form?.data) {
      return;
    }

    const allFields: any[] = this.attributeList || [];

    // Run a few passes to handle chained expressions (A depends on B, B depends on C, etc.)
    let updated = true;
    let iteration = 0;

    while (updated && iteration < 3) {
      updated = false;
      iteration++;

      for (const field of allFields) {
        if (field.type === 'expression' && field.expression) {
          let expr: string = field.expression;
          const dependencies: string[] = (expr.match(/@\w[\w\s]*/g) || []).map(
            (d: string) => d.trim().replace('@', '')
          );

          // ✅ Check if all dependent fields are filled
          const allDepsFilled = dependencies.every((dep: string) => {
            const depField = allFields.find((f: any) => f.label.trim() === dep);
            const depValue = depField ? this.form.data[depField.code] : null;
            return (
              depValue !== undefined && depValue !== null && depValue !== ''
            );
          });

          if (!allDepsFilled) {
            continue;
          }

          // ✅ Replace @labels with actual field values
          for (const f of allFields) {
            const labelKey = `@${f.label}`;
            let value = this.form.data[f.code];
            if (value === undefined || value === null || value === '')
              value = 0;
            expr = expr.replaceAll(labelKey, value);
          }

          try {
            const result = Function('"use strict";return (' + expr + ')')();

            let rounded =
              typeof result === 'number' ? Number(result.toFixed(3)) : result;

            this.form.data[field.code] = rounded;

            updated = true;
          } catch (err) {
            console.error(`❌ Failed to evaluate ${field.code}:`, err);
          }
        }
      }
    }
  }

  //--------------------------------implementing list as radio button and checkbox ----------------//
  onRadioChange(attribute: any, option: string): void {
    this.form.data[attribute.code] = option;
  }

  onListCheckboxChange(attribute: any, option: string, event: any): void {
    const isChecked = event.target.checked;
    const model = this.form.data[attribute.code];

    if (!Array.isArray(model)) {
      this.form.data[attribute.code] = [];
    }

    if (isChecked) {
      if (!this.form.data[attribute.code].includes(option)) {
        this.form.data[attribute.code].push(option);
      }
    } else {
      const index = this.form.data[attribute.code].indexOf(option);
      if (index > -1) {
        this.form.data[attribute.code].splice(index, 1);
      }
    }
  }

  // Add this property at the top of your class
public applogo: Number = 0;

// Add these methods to your component class

getAppDocThumbnail(skey: number) {
  let _self = this;
  if (!skey) {
    if (_self.applogo) {
      skey = Number(_self.applogo);
    } else {
      skey = 0;
    }
  }
  let docAPI = this.locator.config.get('DOC_API');
  let url = docAPI + 'th/' + skey + '?t=' + this.imageTimestamp;
  return url;
}

/**
 * Get application doc
 * @param skey
 */
getAppDoc(skey: number) {
  let _self = this;
  if (!skey) {
    if (_self.applogo) {
      skey = Number(_self.applogo);
    } else {
      skey = 0;
    }
  }
  return _self.getDoc(skey);
}

  
 viewErrorDetails() {
  const modal = document.getElementById('uploadSummaryModal');
  const bsModal = (window as any).bootstrap.Modal.getInstance(modal);
  bsModal?.hide();

  this.router.navigate([
    '/upload-logs',
    this.usecaseId,
    this.uploadResult.uploadId
  ]);
  }
  
openCodeInNewTab(type: string, value: string) {
  if (type === 'qr') {
    QRCode.toDataURL(value, { width: 200 }, (err, url) => {
      if (err) return;
      const win = window.open();
      win!.document.write(`
        <html><head><title>QR Code</title></head>
        <body style="display:flex;align-items:center;justify-content:center;height:100vh;">
          <img src="${url}" alt="QR Code">
        </body></html>
      `);
    });
  } else if (type === 'bar') {
    const win = window.open();
    win!.document.write(`
      <html><head><title>Barcode</title></head>
      <body style="display:flex;align-items:center;justify-content:center;height:100vh;">
        <svg id="barcode"></svg>
        <script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.5/dist/JsBarcode.all.min.js"></script>
        <script>JsBarcode("#barcode","${value}",{format:"CODE128",width:2,height:100,displayValue:true});</script>
      </body></html>
    `);
  }
}

  // --------------- idate issue on database and data and uiform--------
  public convertIntoLocalDate(utc: any) {
    if (!utc) return null;
    const d = new Date(utc);
    const year = d.getFullYear();
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const day = d.getDate().toString().padStart(2, '0');
    const date = `${year}-${month}-${day}`;
    return date;
  }

  setDefaultvalue() {
    console.log('Hello worl set default Value are here : .......');

    this.attributeList.forEach((item: any) => {
      if (item.type === 'date' && item.defaultToCurrentDate) {
        const now = new Date();
        const day = String(now.getDate()).padStart(2, '0');
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const year = now.getFullYear();
        const formattedDate = `${year}-${month}-${day}`;
        this.form.data[item.code] = formattedDate;
      }
      if (item.type === 'idate' && item.defaultToCurrentDate) {
        const now = new Date();
        const day = String(now.getDate()).padStart(2, '0');
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const year = now.getFullYear();
        const formattedDate = `${year}-${month}-${day}`;
        this.form.data[item.code] = formattedDate;
      }
      if (
        (item.type === 'time' && item.defaultToCurrentTime) ||
        item.defaultToCurrentItime
      ) {
        const now = new Date();
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');
        const formattedTime = `${hours}:${minutes}`;
        this.form.data[item.code] = formattedTime;
      }
      if (item.type === 'dateandtime' && item.defaultToCurrentDateAndTime) {
        const now = new Date();
        const day = String(now.getDate()).padStart(2, '0');
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const year = now.getFullYear();
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');
        const formattedDateAndTime = `${year}-${month}-${day} ${hours}:${minutes}`;
        this.form.data[item.code] = formattedDateAndTime;
      }
      if (item.type === 'itime' && item.defaultToCurrentITime) {
        const now = new Date();
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');
        const formattedTime = `${hours}:${minutes}`;
        this.form.data[item.code] = formattedTime;
      }

      if (item.defaultValue) {
        this.form.data[item.code] = item.defaultValue;
      }
    });
  }

  // Tag Implementation ---
  enabletag = 0;
  // Remove the last added tag
  public recordData: any = {};
  public addIndex: any;
  public recordCode: any;
  public textData: any;
  tagListData: any;

  inputValue: string = '';
  selectedTags: string[] = [];
  tagsList: string[] = [];
  filteredTagsList = [...this.tagsList];
  searchTextt = '';

  allAttribute(recordData: any, addIndex: any) {
    console.log('allAttribute called');
    console.log('recordData:', recordData);
    console.log('addIndex:', addIndex);

    this.recordData = recordData;
    this.addIndex = addIndex;
    this.searchText = '';
    this.inputValue = '';

    // ✅ Load attributes first, then setup tags inside callback
    this.getUsecaseDtaa1(() => {
    const tagItem = this.attributeList?.find(
      (item: any) => item.type === 'tag',
    );

    this.tagsList =
      tagItem?.values
        ?.map((t: string) => t.trim())
        .filter((t: string) => t !== '') || [];

    // Load selected tags of that row
    this.selectedTags = recordData.tag
      ? recordData.tag.split(',').map((t: string) => t.trim())
      : [];

    // Show all tags in modal
    this.filteredTagsList = Array.from(
      new Set([...this.tagsList, ...this.selectedTags]),
    );

    console.log('tagsList (available tags):', this.tagsList);
    console.log('selectedTags (pre-selected):', this.selectedTags);
    console.log('filteredTagsList (checkbox list):', this.filteredTagsList);
    });
  }

  getUsecaseDtaa1(callback?: () => void) {
    let _self = this;
    let attrUrl =
      _self.locator.config.get('endpoint.userstory.attributes') +
      '/list/' +
      _self.usecaseId;

    if (
      _self.usecaseId != 0 &&
      _self.usecaseId != null &&
      _self.usecaseId != undefined
    ) {
      _self.locator.http.get(attrUrl, function (res: any, error: boolean) {
        if (error) {
          alert('Server Error:' + error);
          return;
        }

        _self.attributeList = res.result.data;
        console.log('   _self.attributeList', _self.attributeList);

        const tagItem = _self.attributeList?.find(
          (item: any) => item.type === 'tag',
        );

        if (tagItem) {
          _self.tagsList = tagItem.values || [];
          console.log(' _self.tagsList', _self.tagsList);

          // ✅ Fire callback after data is ready
          if (callback) callback();
        } else {
          // CREATE TAG ATTRIBUTE IF NOT EXIST
          console.log('Tag attribute not found. Creating...');

          const payload = {
            label: 'tag',
            type: 'tag',
            userstoryId: _self.usecaseId,
            values: [],
          };

          const saveUrl =
            _self.locator.config.get('endpoint.userstory.attributes') + '/save';

          _self.locator.http.post(
            saveUrl,
            payload,
            function (res2: any, err2: boolean) {
              if (err2) {
                console.error('Tag attribute creation failed');
                return;
              }

              console.log('Tag attribute created successfully');

              // ✅ Reload and fire callback after creation
              _self.getUsecaseDtaa1(callback);
            },
          );
        }
      });
    }
  }

  getCleanTag(tag: string | null | undefined, maxLength: number = 10): string {
    if (typeof tag !== 'string' || tag.trim() === '') return 'Add Tags';
    const clean = tag.replace(/^,\s*/, '').trim();
    return clean.length > maxLength
      ? clean.substring(0, maxLength) + '...'
      : clean;
  }

  // Handle user input in the input field
  onUserInput(event: any) {
    this.searchTextt = event.target.value.toLowerCase().trim();
    // Show filtered only if input is not empty
    if (this.searchTextt) {
      this.filteredTagsList = this.tagsList.filter((tag) =>
        tag.toLowerCase().includes(this.searchTextt),
      );
    } else {
      this.filteredTagsList = [...this.tagsList]; // show all tags
    }
  }

  // saveTags() {
  //   if (!this.recordData) return;

  //   // Step 1: Add new tags to master list
  //   const newTags = this.inputValue
  //     .split(',')
  //     .map((t: string) => t.trim())
  //     .filter((t: string) => t !== '');

  //   console.log('newTags : ' + newTags);

  //   newTags.forEach((tag) => {
  //     if (!this.tagsList.includes(tag)) {
  //       this.tagsList.push(tag);
  //     }
  //     if (!this.selectedTags.includes(tag)) {
  //       this.selectedTags.push(tag);
  //     }
  //   });

  //   this.filteredTagsList = [...this.tagsList];

  //   console.log('Filter data : ' + this.filterAttributes);

  //   // Step 2: Update row tag locally
  //   const finalTags = Array.from(new Set(this.selectedTags));
  //   this.recordData.tag = finalTags.join(',');

  //   console.log('finalTags : ', finalTags);

  //   // Step 3: Save to backend
  //   const url = this.urlRewrite(this.getAPIBaseUrl('save'));

  //   // ✅ send complete object
  //   const payload = { ...this.recordData };

  //   console.log('Full Payload:', payload);

  //   this.locator.http.post(url, payload, (res: any, error: boolean) => {
  //     console.log('Backend response:', res, 'Error flag:', error); // ✅ Step 7

  //     if (error || !res.success) {
  //       alert('Server Error');
  //       return;
  //     }

  //     // Update master tag attribute in backend
  //     const tagAttr = this.attributeList.find(
  //       (item: any) => item.type === 'tag',
  //     );

  //     if (tagAttr) {
  //       tagAttr.values = [...this.tagsList];

  //       const attrUrl =
  //         this.locator.config.get('endpoint.userstory.attributes') + '/save';

  //       this.locator.http.post(attrUrl, tagAttr, () => {});
  //     }
  //     console.log('Input value:', this.inputValue);
  //     console.log('selectedTags before save:', this.selectedTags);
  //     console.log('tagsList before save:', this.tagsList);
  //     this.search(); // refresh table
  //   });

  //   this.inputValue = '';
  // }

  saveTags() {
    if (!this.recordData) return;

    const newTags = this.inputValue
      .split(',')
      .map((t: string) => t.trim())
      .filter((t: string) => t !== '');

    newTags.forEach((tag) => {
      if (!this.tagsList.includes(tag)) this.tagsList.push(tag);
      if (!this.selectedTags.includes(tag)) this.selectedTags.push(tag);
    });

    this.filteredTagsList = [...this.tagsList];

    const finalTags = Array.from(new Set(this.selectedTags));
    this.recordData.tag = finalTags.join(',');

    const url = this.urlRewrite(this.getAPIBaseUrl('save'));

    const filteredData: any = JSON.parse(JSON.stringify(this.recordData));

    // ✅ Get codes for dateandtime, idate, itime
    const dateTimeCodes = this.attributeList
      .filter((item: any) =>
        ['dateandtime', 'idate', 'itime'].includes(item.type),
      )
      .map((item: any) => item.code);

    console.log('dateTimeCodes:', dateTimeCodes);
    console.log('filteredData keys:', Object.keys(filteredData));

    // ✅ Fix ONLY those specific fields
    dateTimeCodes.forEach((code: string) => {
      const value = filteredData[code];
      console.log('checking code:', code, '| value:', value);
      if (typeof value === 'string') {
        // Handle both +00:00 and any ISO format
        filteredData[code] = new Date(value).toISOString();
        console.log('converted:', code, '->', filteredData[code]);
      }
    });

    // ✅ Remove null/empty keys
    Object.keys(filteredData).forEach((key) => {
      if (filteredData[key] === '' || filteredData[key] === null) {
        delete filteredData[key];
      }
    });

    console.log('Final Tag Payload:', filteredData);

    this.locator.http.post(url, filteredData, (res: any, error: boolean) => {
      if (error || !res.success) {
        alert('Server Error');
        return;
      }

      const tagAttr = this.attributeList.find(
        (item: any) => item.type === 'tag',
      );
      if (tagAttr) {
        tagAttr.values = [...this.tagsList];
        const attrUrl =
          this.locator.config.get('endpoint.userstory.attributes') + '/save';
        this.locator.http.post(attrUrl, tagAttr, () => {});
      }

      this.search();
    });

    this.inputValue = '';
  }

  resetTagInput(tagInput: any): void {
    tagInput.value = '';
    this.inputValue = '';
    this.filteredTagsList = [...new Set([...this.tagsList])];
  }

  id: number | undefined;

  onTagCheckboxChange(tag: string, event: Event): void {
    const checkbox = event.target as HTMLInputElement;

    if (checkbox.checked) {
      if (!this.selectedTags.includes(tag)) {
        this.selectedTags.push(tag);
      }
    } else {
      this.selectedTags = this.selectedTags.filter((t) => t !== tag);
    }

    // ✅ Build full payload like saveTags does
    const filteredData: any = JSON.parse(JSON.stringify(this.recordData));

    // ✅ Override tag with current selected tags
    filteredData['tag'] = this.selectedTags.join(', ');

    // ✅ Convert date/time fields
    const dateTimeCodes = this.attributeList
      .filter((item: any) =>
        ['dateandtime', 'idate', 'itime'].includes(item.type),
      )
      .map((item: any) => item.code);

    dateTimeCodes.forEach((code: string) => {
      const value = filteredData[code];
      if (typeof value === 'string') {
        filteredData[code] = new Date(value).toISOString();
      }
    });

    // ✅ Remove null/empty keys
    Object.keys(filteredData).forEach((key) => {
      if (filteredData[key] === '' || filteredData[key] === null) {
        delete filteredData[key];
      }
    });

    console.log('Full Tag Payload:', filteredData); // ✅ use comma not +

    const url = this.urlRewrite(this.getAPIBaseUrl('save'));

    this.locator.http.post(url, filteredData, (res: any, error: boolean) => {
      if (error) {
        alert('Server Error:' + error);
        return;
      }

      this.form['error'] = !res.success;
      this.form['message'] = res.message;
      this.form['inputerror'] = res.result?.inputerror ?? null;
      this.form['inputerrormsg'] = res.result?.inputerror
        ? Object.values(res.result.inputerror).join(', ')
        : '';

      if (!res.success) return;

        this.form['data']['id'] = res.result['data']['id'];
      this.id = res.result['data']['id'];

        this.textData = res.result.data.tag ?? '';
        this.tagListData = this.textData
          .split(',')
          .map((t: string) => t.trim())
          .filter((t: string) => t !== '');
        this.selectedTags = [...this.tagListData];

        if (this.recordData) {
          this.recordData['tag'] = this.textData;
        }

        this.search();
    });
  }

  getFullTag(tag: string | null | undefined): string {
    if (typeof tag !== 'string' || tag.trim() === '') return 'Add Tags';
    return tag.replace(/^,\s*/, '').trim();
  }
}
